import keyBy from 'lodash/keyBy';
import { currentUserSelector } from 'app/selectors/AuthSelector';
import { getShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import composeGlobalSuccessMessaging from './composeGlobalSuccessMessaging';

export default function composeUgcSuccessMessaging({ response, store, metadataId, type }) {
  const userId = currentUserSelector(store.getState()).get('id');
  const shelfItem = keyBy(response.entities.shelves[userId], d => d.metadataId);
  const existingShelfItem = !!getShelvesForCurrentUser(store.getState()).get(metadataId);
  const shelfKey = existingShelfItem ? 'shelf_existing' : 'shelf_added';
  const privateItemKey = shelfItem[metadataId].privateItem ? 'private' : 'public';
  const action = type === 'rating' ? 'rating' : 'ugc';
  const messageId = `success_${action}_${shelfKey}_${privateItemKey}`;
  const values = { ugcType: type };
  return composeGlobalSuccessMessaging(messageId, type === 'rating' ? {} : { values });
}
